import ProductInterface from '../ProductInterface';
import OcchrlyOptions from './OcchrlyOptions';
import { processOcchrly } from './occhrlyProcess';

export default function Occhrly() {
  return (
      <ProductInterface
          product = "occhrly"
          ProductOptions = {OcchrlyOptions}
          processProduct = {processOcchrly}
      />
  )
} 